import { SkywardItemColor } from '@bg-shared/enums/SkywardItemColor';

export const getSkywardItemColor = (number: number): SkywardItemColor => {
    if (number < 2) {
        return SkywardItemColor.LOW_MULTIPLIER;
    }

    if (number < 10) {
        return SkywardItemColor.MEDIUM_MULTIPLIER;
    }

    return SkywardItemColor.HIGH_MULTIPLIER;
};
